import { render, staticRenderFns } from "./color-custom-colors.vue?vue&type=template&id=5835be0e&scoped=true"
import script from "./color-custom-colors.vue?vue&type=script&lang=js"
export * from "./color-custom-colors.vue?vue&type=script&lang=js"
import style0 from "./color-custom-colors.vue?vue&type=style&index=0&id=5835be0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5835be0e",
  null
  
)

export default component.exports